import '../vendors/share-popup-dialog';

class Share {
    constructor(selector) {
    	this.shareDialog = $(selector);
		this.init();
    }

    init() {
		if (!this.shareDialog) return;

		$(this.shareDialog).on("click", function(e) {
			$(this).customerPopup(e);
		});
    }
}

export default Share;



// WEBPACK FOOTER //
// ./scripts/modules/share.js